import React from 'react'

import {
  Button,
  AlignItems,
  Box,
  ButtonColorVariant,
  Display,
  FontFamily,
  Icon,
  IconVariant,
  JustifyContent,
  Link,
  Text,
  useTheme,
} from '@gousto-internal/citrus-react'
import type Immutable from 'immutable'
import moment from 'moment'

import { client as clientRoutes } from 'config/routes'
import { getSlotTimes } from 'utils/deliveries'

import css from '../Details.css'

type DateHeaderProps = {
  orderId: string
  date: string
  deliveryDays: Immutable.Map<string, any>
  slotId: string
  clearSlot: () => void
}

export const DateHeader: React.FC<DateHeaderProps> = (props) => {
  const { theme } = useTheme()
  const { orderId, date, deliveryDays, slotId, clearSlot } = props

  const text = date
    ? `${moment(date).format('ddd Do MMM')}, ${getSlotTimes({
        date,
        deliveryDays,
        slotId,
      })}`
    : `${moment(Date.now()).format('ddd Do MMM')}, 8am - 7pm`

  if (orderId) {
    return (
      <div className={css.row}>
        <p className={css.deliverySlotText}>
          Edit recipes for your upcoming order. To change date or cancel order, visit{' '}
          <Link href={clientRoutes.myDeliveries} size={1} style={{ boxShadow: 'none' }}>
            &apos;Upcoming deliveries&apos;
          </Link>
        </p>
        <p className={css.dateText}>{text}</p>
      </div>
    )
  }

  return (
    <Button
      colorVariant={ButtonColorVariant.Secondary}
      width="100%"
      data-testid="edit-delivery-slot"
      onClick={clearSlot}
      style={{
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      }}
    >
      <Box
        display={Display.Flex}
        width="100%"
        justifyContent={JustifyContent.SpaceBetween}
        alignItems={AlignItems.Center}
      >
        <Text size={4} fontFamily={FontFamily.Bold} className={css.headerButtonText}>
          {text}
        </Text>
        <Box display={Display.Flex} className={css.headerAction}>
          <Icon size={4} name="edit" variant={IconVariant.Actionable} />
          <Text size={1} fontFamily={FontFamily.Bold}>
            edit
          </Text>
        </Box>
      </Box>
    </Button>
  )
}
